<template>
  <v-layout row wrap class="pr-0 py-0 text-xs-center">
    <v-flex xs4>
      <v-menu transition="slide-y-transition" bottom>
        <template v-slot:activator="{ on }">
          <v-btn class="font-weight-bold" color="#333333" outline v-on="on">
            カラーパレット
            <svg id="select-color" xmlns="http://www.w3.org/2000/svg">
              <!-- グラフの背景色 -->
              <rect x="0" y="0" width="30" height="25" stroke-width="2" stroke="none" :fill="nowColor.bg" />
              <!-- グラフの色 -->
              <rect x="0" y="13" width="30" height="12" stroke-width="1" :stroke="nowColor.base" :fill="nowColor.base" fill-opacity="0.5" />
            </svg>
          </v-btn>
        </template>
        <v-card>
          <v-layout row wrap>
          <v-flex xs3 v-for="(colorRow, colorKey) in colors" v-bind:key="colorKey">
            <svg xmlns="http://www.w3.org/2000/svg" @click="selectColor(colorKey)">
              <!-- グラフの背景色 -->
              <rect x="0" y="0" width="50" height="40" stroke-width="1" stroke="none" :fill="colorRow.bg" />
              <!-- グラフの色 -->
              <rect x="0" y="20" width="50" height="40" stroke-width="1" :stroke="colorRow.base" :fill="colorRow.base" fill-opacity="0.5" />
            </svg>
          </v-flex>
        </v-layout>
        </v-card>
      </v-menu>
    </v-flex>
  </v-layout>
</template>

<script>
import ColorUtils from '@/components/common/ColorUtils.js';

export default {
  name: 'ColorPalette',
  props: {
    baseColorId: {
      type: Number,
      default: 1
    },
    colorId: {
      type: Number,
      default: 1
    }
  },
  data: () => {
    return {
      // 全色配列
      colors: [],
      // 今選択されている色セット
      nowColor: {},
      // パレットの表示/非表示
      isHidePalette: true
    };
  },
  computed: {
    setBaseColor() {
      return this.baseColorId;
    },
    setColor() {
      return this.colorId;
    }
  },
  watch: {
    setBaseColor() {
      let key = this.baseColorId - 1;
      this.initBaseColorPalette(key);
    },
    setColor() {
      let key = this.colorId - 1;
      this.initColorPalette(key);
    }
  },
  methods: {
    /**
     * カラーパレットの初期化
     */
    initBaseColorPalette(key) {
      // JSONからColorオブジェクトを引き込む
      this.colors = ColorUtils.convertJsonToColorObject();
      // 今選択されている色を、colorsの最初の色にする
      this.nowColor = this.colors[key];
      this.$emit('base-color-init', this.nowColor);
    },
    initColorPalette(key) {
      // JSONからColorオブジェクトを引き込む
      this.colors = ColorUtils.convertJsonToColorObject();
      // 今選択されている色を、colorsの最初の色にする
      this.nowColor = this.colors[key];
      this.$emit('color-init', this.nowColor);
    },
    /**
     * 色の選択
     */
    selectColor(colorKey) {
      // 今選択されている色を反映する
      this.nowColor = this.colors[colorKey];
      this.$emit('color-select', this.nowColor);
    }
  },
  created() {
    let key = this.colorId - 1;
    this.initBaseColorPalette(key);
    this.initColorPalette(key);
  }
};
</script>

<style scoped lang="scss">
svg {
  margin: 3px 8px;
  background-color: rgb(255, 255, 255);
  width: 50px;
  height: 40px;
}

#select-color {
  margin: 3px 8px;
  background-color: rgb(255, 255, 255);
  width: 30px;
  height: 25px;
}

div {
  #color-palette-base {
    width: 100%;
  }
}
</style>
